import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

export default function Logo({ sx }) {
  return (
    <RouterLink to="/">
      <Box component="img" src="/static/logo.svg" sx={{ width: 40, height: 40, ...sx }} />
    </RouterLink>
  );
}

Logo.propTypes = {
  sx: PropTypes.shape({}),
};

Logo.defaultProps = {
  sx: undefined,
};
